/* eslint-disable @typescript-eslint/no-unused-vars */
import type { FC } from 'react';

import { IconName, theme, formatPhoneNumber } from '@catalyze/ui';

import { IconButton, PhoneLabel } from './styled';

import { ContactContainer } from '../ContactContainer';
import { ContactIcon } from '../ContactIcon';
import { ContactSubtitle } from '../ContactSubtitle';
import { ContactTitle } from '../ContactTitle';

interface IContactLine {
    contactDetail: string;
    contactUsed: string;
    hasDoNotCall: boolean;
    onClick: () => void;
}

export const ContactPhones: FC<IContactLine> = ({
    contactDetail,
    contactUsed,
    hasDoNotCall,
    onClick,
}) => (
    <ContactContainer>
        <IconButton type="button" onClick={onClick}>
            <ContactIcon
                icon={IconName.PHONE}
                contacted={contactUsed.length > 0}
            />
        </IconButton>
        <div>
            <ContactTitle>{formatPhoneNumber(contactDetail)}</ContactTitle>
            <ContactSubtitle>{contactUsed}</ContactSubtitle>
        </div>

        {hasDoNotCall ? <PhoneLabel color={theme.colors.contacted} /> : null}
    </ContactContainer>
);
